import {importFile, MainRequest} from '../../../Services/common';
import {download} from '../../../Utils/common';

export interface QueryMenuList {
    levelType?: string; // 类型
    name?: string; // 名称
}

export interface MenuItem {
    id: string;
    name: string; // 名称
    code: string; // 编码
    levelType: string; //  类型
    sort: string; // 排序
    parentId: string; // 父级
    children?: string[];
}

/**
 * 菜单分页
 * @param query
 * @param pagination
 */
export function menuList(query: QueryMenuList, pagination: Pagination) {
    return MainRequest.post<PagedSuccessData<MenuItem[]>>('/function/page', {
        ...query,
        ...pagination,
    }).then(res => res.data.data);
}

/**
 * 所有一级目录
 */
export async function getDirList() {
    const data = await menuList({}, {pageSize: 9999, pageNo: 1});
    return data.data.filter(item => item.levelType === 'DIMTYPE100001');
}

/**
 * 菜单保存
 * @param data
 */
export function menuSave(data: MenuItem) {
    return MainRequest.post('/function/save', data);
}

export interface ActionItem {
    id: string;
    name: string; // 名称
    code: string; //  编码
    url: string; //  接口url
    parentId: string;
}

/**
 * 操作项列表
 * @param parentId
 */
export function listAction(parentId: string) {
    return MainRequest.post<SuccessData<ActionItem[]>>('/function/listAction', {
        parentId,
    }).then(res => res.data.data);
}

export interface ActionData {
    parentId: string;
    name: string;
    code: string;
    url: string;
}

/**
 * 新增操作项
 * @param parentId
 * @param data
 */
export function addAction(parentId: string, data: ActionData) {
    return MainRequest.post('/function/addAction', {...data, parentId});
}

/**
 * 删除操作项
 * @param id
 */
export function deleteAction(id: string) {
    return MainRequest.post('/function/deleteAction', {id});
}

/**
 * Excel导入菜单数据
 * @param file
 */
export function importExcel(file: File) {
    return importFile('/function/importExcel', file);
}

/**
 * excel导入功能
 * @param file
 */
export function importExcel2(file: File) {
    return importFile('/function/importExcel2', file);
}

/**
 * excel导出
 */
export function exportExcel(query: QueryMenuList) {
    return download('/function/exportExcel', {method: 'post', data: query});
}

export function f() {
    return MainRequest.post('function/listHistory');
}
